module.exports = __webpack_public_path__ + "img/default-coverimg.f52a0200.png";